import React, {Component} from "react";
import {Table, Thead, Tbody, Tr, Th, Td} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import moment from "moment";
import { formatMoney } from "helpers/currency";
import { serviceLabel } from "helpers/adminLabels";


class InvoicingList extends Component {
  constructor(props) {
    super(props);
    this.currentRefundAmount = 0;
  }

  currentRefundAmount = 0;

  accumRefunds( booking_refunds ){
    this.currentRefundAmount = 0;
    if( booking_refunds && booking_refunds[0] ){
      booking_refunds.forEach((refund) => {
        //this.currentRefundAmount += (refund.refund.amount/100);
        if( refund.id_payment.kind === 'refundId' ){
          this.currentRefundAmount += (refund.price);
        }
      });
    }
    return this.currentRefundAmount;
  }

  tableRowElement(bookings) {
    if (bookings) {
      const {btn} = this.props;
      this.currentRefundAmount = 0;
      return bookings.map((booking) => {
        // Skip bookings with null booking object
        if (!booking.booking) {
          console.warn('Booking object is null for transaction:', booking._id);
          return null;
        }

        this.accumRefunds(booking.booking?.transactions);
        let trns = serviceLabel(booking.booking?.description);

        if( trns.length===0 ){
          trns = booking.booking?.meetingType;
        }

        // Skip fully refunded bookings (before summing, so hidden rows don't count in the totals)
        if( Number(this.currentRefundAmount.toFixed(2)) >= Number(Number(booking.price).toFixed(2)) ){
          return null;
        }

        this.props.addSums(booking.price,booking.hpnAmount, this.currentRefundAmount );

        return (
          <Tr key={booking._id}>
            <Td>
              {btn && (
                <input
                  type="checkbox"
                  onClick={() => this.props.addTransactionForInvoice(booking._id)}
                />
              )}
              {!btn && (
                <input
                  type="checkbox"
                  onClick={() => this.props.issueInvoice(booking.professional?._id)}
                />
              )}
              {booking._id}
            </Td>
            <Td>{booking.professional?.name} {booking.professional?.surname}</Td>
            <Td>{trns}</Td>
            <Td>{booking.bookingState}</Td>
            <Td>{booking.booking?.status}</Td>
            <Td>{formatMoney(booking.price, { locale: "bg" })}</Td>
            <Td>{formatMoney(this.currentRefundAmount, { locale: "bg" })}</Td>
            <Td>{formatMoney(booking.hpnAmount, { locale: "bg" })}</Td>
            <Td>{booking.hpnCommision}</Td>
            <Td>{booking.booking?.createdAt ? moment(booking.booking.createdAt).format('DD MMM YYYY') : 'N/A'}</Td>
            <Td>{moment(booking?.booking?.time).format("DD MMM YYYY")}<br/>{moment(booking?.booking?.time).format("HH:mm")}</Td>
          </Tr>
        );
      });
    }
  }

  render() {
    const {list} = this.props;
    const {btn} = this.props;
    return (
      <div className="table-rep-plugin">
        <div className="table-responsive mb-0" data-pattern="priority-columns">

        {!btn && (
          <h2 className="text-center">ИЗБЕРИ КОНТРАГЕНТ по резервация</h2>
        )}

        {btn && list[0] && (
          <span className="text-left">
              <b>Фактурата ще бъде издадена на:</b><br/>
              {list[0].professional.metadata.companyName && (
                <div>Получател / Recipient: <b> { list[0].professional.metadata.companyName } { list[0].professional.metadata.formOfEstablishment}</b></div>
              )}
              {!list[0].professional.metadata.companyName &&(
                <div>Получател / Recipient: <b>{ `${list[0].professional.name} ${list[0].professional.surname}` }</b></div>
              )}

              <div>ДДС / VAT: <b>{ list[0].professional.metadata.vat?.vatNumber || '9999999999' }</b></div>
              <div>ЕИК / UIN: <b>{ list[0].professional.metadata.taxNumber || '' }</b>
              { list[0].professional.metadata.vat?.accountablePerson ? `МОЛ / MRP: ${list[0].professional.metadata?.vat?.accountablePerson}` : '' }
              </div>

              <div>Услуги от / Service by: <b>{` ${list[0].professional.name} ${list[0].professional.surname}` }</b></div>
              <br/>
          </span>
        )}

          <Table
            id="tech-companies-1"
            className="table table-striped table-bordered"
          >
            <Thead>
              <Tr>
                <Th data-priority="1"></Th>
                <Th data-priority="1">Специалист</Th>
                <Th data-priority="3">Услуга</Th>
                <Th data-priority="3">Статус</Th>
                <Th data-priority="3">Статус на резервацията</Th>
                <Th data-priority="1">Цена на услугата</Th>
                <Th data-priority="1">Възстановяване</Th>
                <Th data-priority="3">HPN цена</Th>
                <Th data-priority="3">Вид такса</Th>
                <Th data-priority="3">Резервирана на</Th>
                <Th data-priority="3">Дата на събитието</Th>
              </Tr>
            </Thead>
            <Tbody>{this.tableRowElement(list)}</Tbody>
            <Thead>
              <Tr>
                <Th data-priority="1"></Th>
                <Th data-priority="1"></Th>
                <Th data-priority="3"></Th>
                <Th data-priority="3"></Th>
                <Th data-priority="3"></Th>
                <Th data-priority="1">{btn?formatMoney(this.props.getAccrued(), { locale: "bg" }):''}</Th>
                <Th data-priority="1">{btn?formatMoney(this.props.getRefunds(), { locale: "bg" }):''}</Th>
                <Th data-priority="3">{btn?formatMoney(this.props.getForInvoice(), { locale: "bg" }):''}</Th>
                <Th data-priority="3"></Th>
                <Th data-priority="3"></Th>
                <Th data-priority="3"></Th>
                <Th data-priority="3"></Th>
              </Tr>
            </Thead>
          </Table>
        </div>

      </div>
    );
  }
}

export default InvoicingList;
